export const FIELDS = {
    FIELD_EMAIL: 'email',
    FIELD_PASSWORD: 'password',
};

export const fields = [FIELDS.FIELD_EMAIL, FIELDS.FIELD_PASSWORD];

export const regexMap = {
    email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,100}$/i,
    min: /^(.{5,}?$)/,
    max: /^(?!(\w{129,}?$))/,
};

export const EMAIL_MAX_LENGTH = 256;
